<template>
  <el-dialog
    title="重命名角色"
    :visible.sync="nameVisible"
    :before-close="handleCancel"
    width="550px"
  >
    <div class="permissions-setting">
      <div class="label">
        角色名称：
      </div>
      <div class="setting">
        <el-input
          v-model="role_name"
          placeholder="自建角色"
        />
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCancel">取 消</el-button>
      <el-button
        type="primary"
        @click="updatRoleName"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: 'nameVisible',
    event: 'nameVisibleChange'
  },
  props: {
    nameVisible: {
      type: Boolean,
      default: false
    },
    updateItem: {
      type: Object
    }
  },
  data () {
    return {
      role_name: ''
    }
  },
  watch: {
    updateItem: {
      handler (newValue) {
        if (newValue) {
          this.role_name = newValue.role_name
        }
      }
    }
  },
  mounted () {},
  methods: {
    // 修改用户角色
    async updatRoleName () {
      let role_id = this.updateItem.role_id
      const data = await this.$api.setting.editRole(role_id, {
        role_id,
        role_name: this.role_name
      })
      if (data) {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.updateItem.role_name = this.role_name
        this.handleCancel()
      }
    },

    handleCancel () {
      this.$emit('refresh')
      this.$emit('nameVisibleChange', false)
    }
  }
}
</script>

<style lang="scss" scoped>
// 权限设置
.permissions-setting {
  display: flex;
  justify-content: center;
  .label {
    line-height: 36px;
  }
  .setting {
    .select {
      width: 300px;
    }
    .setting-tips {
      color: #909399;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
